export enum ScreenSizeEnum {
    XSmall,
    Small,
    Medium,
    Large,
    XLarge,
    XXLarge
}
